import { RefObject, useEffect, useMemo, useState } from 'react';

const useOnScreen = (ref: RefObject<HTMLDivElement | null>) => {
    const [isIntersecting, setIntersecting] = useState(false);

    const observer = useMemo(
        () => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ref]
    );

    useEffect(() => {
        if (ref?.current) {
            observer.observe(ref.current);
        }
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return isIntersecting;
};
export { useOnScreen };
